module.exports = __webpack_public_path__ + "img/chn.02c229de.svg";